import { render, staticRenderFns } from "./CommentTextarea.vue?vue&type=template&id=88ceac36&"
import script from "./CommentTextarea.vue?vue&type=script&lang=js&"
export * from "./CommentTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports